import React from "react"
import { graphql } from "gatsby"
import { StposYaml } from "../../types/graphql-types"

export const stposQuery = graphql`
  fragment StPOs on StposYaml {
    id
    since {
      ...Semesters
    }
    title {
      long
      short
    }
  }
`

interface StpoSelector {
  stpos: StposYaml[]
  activeStpo: StposYaml
  setActiveStpo: (stpo: StposYaml) => void
}

const StpoSelector: React.FC<StpoSelector> = ({
  stpos,
  activeStpo,
  setActiveStpo,
}) => {
  return (
    <div className="mb-8 border-b borber-b-umr-grey-200 pb-1">
      <ul>
        {stpos
          .sort((a, b) => a.id.localeCompare(b.id))
          .map(stpo => (
            <li className="inline-block mr-2" key={stpo.id}>
              <button
                className={`px-3 py-3 mr-2 rounded-t-lg outline-none font-semibold text-xl text-fb12-red-500 border-b-4 hover:border-fb12-red-200 ${
                  activeStpo.id === stpo.id
                    ? "border-fb12-red-500"
                    : "border-transparent"
                }`}
                onClick={() => setActiveStpo(stpo)}
              >
                {stpo?.title.short}
              </button>
            </li>
          ))}
      </ul>
    </div>
  )
}

export default StpoSelector
